import { render, staticRenderFns } from "./OrgEdit.vue?vue&type=template&id=c7aaf0ac&scoped=true"
import script from "./OrgEdit.vue?vue&type=script&lang=js"
export * from "./OrgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aaf0ac",
  null
  
)

export default component.exports